import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const SidePanel = ({ 
  isOpen, 
  onClose, 
  children, 
  title,
  position = 'right', // 'left', 'right', 'bottom'
  width = 'max-w-md',
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const getPositionClasses = () => {
    switch (position) {
      case 'left':
        return 'left-0 top-0 bottom-0 w-full sm:w-96';
      case 'right':
        return 'right-0 top-0 bottom-0 w-full sm:w-96';
      case 'bottom':
        return 'bottom-0 left-0 right-0 h-[80vh] rounded-t-3xl';
      default:
        return 'right-0 top-0 bottom-0 w-full sm:w-96';
    }
  };

  const getTransformClasses = () => {
    switch (position) {
      case 'left':
        return 'animate-slideInLeft';
      case 'right':
        return 'animate-slideInRight';
      case 'bottom':
        return 'animate-slideInBottom';
      default:
        return 'animate-slideInRight';
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 z-50 transition-opacity"
        onClick={onClose}
      />

      {/* Panel */}
      <div className={`fixed ${getPositionClasses()} bg-white z-50 shadow-2xl ${getTransformClasses()}`}>
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-stone-200">
          <h2 className="font-serif text-lg font-medium text-stone-900">{title}</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-stone-100 rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-stone-600" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto h-[calc(100%-64px)] p-4">
          {children}
        </div>
      </div>

      <style jsx>{`
        @keyframes slideInLeft {
          from { transform: translateX(-100%); }
          to { transform: translateX(0); }
        }
        @keyframes slideInRight {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        @keyframes slideInBottom {
          from { transform: translateY(100%); }
          to { transform: translateY(0); }
        }
        .animate-slideInLeft { animation: slideInLeft 0.3s ease-out; }
        .animate-slideInRight { animation: slideInRight 0.3s ease-out; }
        .animate-slideInBottom { animation: slideInBottom 0.3s ease-out; }
      `}</style>
    </>
  );
};

export default SidePanel;